import { BrowserRouter } from "react-router-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { ConfigProvider, theme  } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
//import "antd/dist/antd.css";
import 'antd/dist/reset.css';
import Router from "./router";
import i18n from "./translation";

const App = () => (
  <HelmetProvider>
  <BrowserRouter basename="/">
    <ConfigProvider
    theme={{
      algorithm: theme.darkAlgorithm,
    }} >
    <I18nextProvider i18n={i18n}>
      <Router />
    </I18nextProvider>
    </ConfigProvider>
  </BrowserRouter>
  </HelmetProvider>
);

const container = document.getElementById("root");

// Use hydration if pre-rendered content exists (react-snap)
if (container?.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  const root = createRoot(container!);
  root.render(<App />);
}
